// extracted by mini-css-extract-plugin
export default {"root":"NoProject_root__oEP-N"};